export const UserActions = {
  // For Login Keys

  USER_LOGIN: "USER_LOGIN",
  USER_LOGIN_WITH_USERNAME: "USER_LOGIN_WITH_USERNAME",
  SET_LOGIN_USER_DATA: "SET_LOGIN_USER_DATA",



// Forgot Password Keys

  USER_FORGOT_PASSWORD:"USER_FORGOT_PASSWORD",
  IS_USER_FORGOT_PASSWORD: "IS_USER_FORGOT_PASSWORD",

  // For Logout Keys

  USER_LOGOUT: "USER_LOGOUT",
  IS_USER_LOGOUT: "IS_USER_LOGOUT",

  // For Loader Keys

  SET_LOADER: "SET_LOADER",
  SET_LOADER_USER_LOGIN: "SET_LOADER_USER_LOGIN",
  SET_LOADER_USER_LOGOUT: "SET_LOADER_USER_LOGOUT",
  SET_LOADER_SAVE_BUTTON: "SET_LOADER_SAVE_BUTTON",
  SET_LOADER_UPDATE_ACCOUNT_PWD_BUTTON: "SET_LOADER_UPDATE_ACCOUNT_PWD_BUTTON",
  SET_LOADER_NOTIFICATION: "SET_LOADER_NOTIFICATION",

  // For Notification Keys

  GET_NOTIFICATION_LIST: "GET_NOTIFICATION_LIST",
  SET_NOTIFICATION_LIST: "SET_NOTIFICATION_LIST",

  UPDATE_NOTIFICATION_LIST: "UPDATE_NOTIFICATION_LIST",

  // define other action types here
};
